import React, { useState } from "react";

const testimonials = [
  {
    image:
      "https://images.pexels.com/photos/6646919/pexels-photo-6646919.jpeg?auto=compress&cs=tinysrgb&w=800",
    title: "Community Food Drive",
    text: "Amazing support from our volunteers helped feed hundreds...",
  },
  {
    image:
      "https://images.pexels.com/photos/6994984/pexels-photo-6994984.jpeg?auto=compress&cs=tinysrgb&w=800",
    title: "Helping Hands Initiative",
    text: "Thanks to everyone who donated and volunteered their time...",
  },
  {
    image:
      "https://images.pexels.com/photos/6647037/pexels-photo-6647037.jpeg?auto=compress&cs=tinysrgb&w=800",
    title: "Donation Box Project",
    text: "Your generosity filled every donation box this season...",
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section className="py-20 text-center transition-all duration-500">
      <h2 className="text-[50px] font-semibold mb-12">
        Testimonials
      </h2>

      <div className="relative flex items-center justify-center flex-wrap">
        {/* Left Arrow */}
        <button
          onClick={prevSlide}
          className="absolute left-[5%] text-4xl text-black p-2"
        >
          &#8249;
        </button>

        {/* Testimonial Box */}
        <div className="w-[80%] max-w-[1100px] h-[330px] flex bg-white rounded-2xl overflow-hidden shadow-lg mt-6">
          {/* Image */}
          <div className="w-[45%] h-full">
            <img
              src={testimonials[current].image}
              alt="testimonial"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="w-[55%] p-12 text-left">
            <h3 className="text-[26px] mb-4 text-gray-800">
              {testimonials[current].title}
            </h3>
            <p className="text-[16px] text-gray-600 leading-relaxed">
              {testimonials[current].text}
            </p>
            <span className="inline-block mt-4 text-[#00b3a4] font-medium cursor-pointer">
              Read more →
            </span>
          </div>
        </div>

        {/* Right Arrow */}
        <button
          onClick={nextSlide}
          className="absolute right-[5%] text-4xl text-black p-2"
        >
          &#8250;
        </button>
      </div>

      {/* Dots */}
      <div className="mt-6">
        {testimonials.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrent(index)}
            className={`inline-block w-[10px] h-[10px] mx-1.5 rounded-full cursor-pointer transition ${
              index === current ? "bg-black" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
